<template>
    <div>
        <v-container>
            <v-row>
                <v-card>
                    <!-- Alert message -->
                    <v-card-text>
                        Your account is still in the onboarding stage. Please ensure you have E-Signed the relevant
                        documents.
                        If you have completed this stage, your account will be unlocked once this has been reviewed and
                        approved by admin.
                    </v-card-text>
                    <!-- Buttons -->
                    <v-card-actions>
                        <v-btn v-on:click="refreshPage" class="float-right"
                            :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'">Refresh Page</v-btn>
                    </v-card-actions>

                </v-card>
            </v-row>
        </v-container>
    </div>
</template>
<script>

export default {
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {
        refreshPage: () => {
            window.location.reload(); // Reloads the current page
        }
    }
}
</script>